import { useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useReassignTransaction } from "../../../hooks/queries/useTransactionQueries";
import { toastService } from "../../../providers";
import { REASSIGN_FORM_INITIAL_VALUES } from "../utils/transactionValidators";

export const useReassignTransactionModal = (merchantOptions = []) => {
  const [isOpen, setIsOpen] = useState(false);
  const [transaction, setTransaction] = useState(null);

  const { control, handleSubmit: rhfHandleSubmit, reset } = useForm({
    defaultValues: REASSIGN_FORM_INITIAL_VALUES,
    mode: "onTouched",
  });

  const { mutate: reassignMutate, isPending: isSubmitting } =
    useReassignTransaction();

  const openModal = useCallback(
    (row) => {
      if (!row || Object.keys(row).length === 0) {
        toastService.error(
          "Cannot open reassignment modal: invalid transaction data.",
        );
        return;
      }
      if (!merchantOptions || merchantOptions.length === 0) {
        toastService.error(
          "Cannot open reassignment modal: no merchants available.",
        );
        return;
      }

      setTransaction(row);
      reset({ merchantId: row?.merchant?.id || "", reason: "" });
      setIsOpen(true);
    },
    [merchantOptions, reset],
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setTransaction(null);
    reset(REASSIGN_FORM_INITIAL_VALUES);
  }, [reset]);

  const onSubmit = useCallback(
    (values) => {
      if (!transaction) return;

      const transactionId = transaction.transactionId || "";

      reassignMutate(
        {
          merchantId: values.merchantId,
          transactionId,
          reason: values.reason,
        },
        {
          onSuccess: () => {
            toastService.success("Transaction reassigned successfully.");
            closeModal();
          },
          onError: (_err) => {
            toastService.error("Failed to reassign transaction.");
          },
        },
      );
    },
    [reassignMutate, transaction, closeModal],
  );

  return {
    isOpen,
    transaction,
    control,
    handleSubmit: rhfHandleSubmit(onSubmit),
    openModal,
    closeModal,
    isSubmitting,
  };
};

export default useReassignTransactionModal;
